import ArrayField from 'react-jsonschema-form/lib/components/fields/ArrayField';
import FilterFields from './FilterFields';
import InitialEmptyItem from './InitialEmptyItem';
import ImproveAccessibility from "./ImproveAccessibility";

export default ArrayField |> ImproveAccessibility |> FilterFields |> InitialEmptyItem;
